import React from 'react';
import { useRouter } from 'next/router';
import { useForm, Controller } from 'react-hook-form';
import { Input, Button } from 'clad-ui';
import { styled } from '@linaria/react';
import Link from 'next/link';
export type LoginInputs = {
  phone: string;
  password: string;
};
type Props = {
  onSubmit?: (data: LoginInputs) => void;
  isLoading?: boolean;
  defaultPhone?: string;
  goForgotPassword?: () => void;
  onInvalid?: () => void;
};
const LoginForm = (props: Props) => {
  const {
    onSubmit: onLogin = () => {},
    isLoading = false,
    defaultPhone,
    goForgotPassword,
    onInvalid = () => {}
  } = props;
  const {
    query
  } = useRouter();
  const {
    control,
    handleSubmit
  } = useForm<LoginInputs>({
    defaultValues: {
      phone: defaultPhone
    }
  });
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleSubmit(onLogin, onInvalid)();
  };
  const acceptNumberOnly = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.replace(/\D/g, '');
    return event;
  };
  return <FormWrapper method="post" onSubmit={onSubmit}>
      <Controller name="phone" control={control} rules={{
      required: {
        value: true,
        message: 'Vui lòng nhập số điện thoại.'
      },
      /** phone number start with 121 support for testing */
      pattern: {
        value: /^0\d{9}$|^121\d{7}$/,
        message: 'Số điện thoại không hợp lệ.'
      }
    }} render={({
      field: {
        ref,
        ...field
      },
      fieldState: {
        invalid,
        error
      }
    }) => <Input {...field} id="phone-input" label="Số điện thoại" type="tel" inputMode="numeric" allowClear helptext={error?.message} status={invalid ? 'error' : 'default'} onChange={(event: React.ChangeEvent<HTMLInputElement>) => field.onChange(acceptNumberOnly(event))} />} />
      <Controller name="password" control={control} rules={{
      required: {
        value: true,
        message: 'Vui lòng nhập mật khẩu.'
      }
    }} render={({
      field: {
        ref,
        ...field
      },
      fieldState: {
        invalid,
        error
      }
    }) => <Input {...field} id="password-input" type="password" label="Mật khẩu" showPassword helptext={error?.message} status={invalid ? 'error' : 'default'} />} />

      <Link id="forgot-password-btn" onClick={goForgotPassword} href={`/forget-password?continue=${query.continue || ''}`} className="forgot-password-btn">
        Quên mật khẩu?
      </Link>

      <Button id="login-btn" size="large" weight="bold" stretch extraClasses="login-btn" isLoading={isLoading}>
        Đăng nhập
      </Button>
    </FormWrapper>;
};
const FormWrapper = /*#__PURE__*/styled('form')({
  name: "FormWrapper",
  class: "fei2bp7",
  propsAsIs: false
});
export default LoginForm;

require("./LoginForm.linaria.module.css");